import _createForOfIteratorHelper from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { Absorber } from "./Options/Classes/Absorber";
import { AbsorberInstance } from "./AbsorberInstance";
import { itemFromArray } from "../../Utils/Utils";
export var Absorbers = /*#__PURE__*/function () {
  function Absorbers(container) {
    var _this = this;
    _classCallCheck(this, Absorbers);
    this.container = container;
    this.array = [];
    this.absorbers = [];
    this.interactivityAbsorbers = [];
    var overridableContainer = container;
    overridableContainer.getAbsorber = function (idxOrName) {
      return idxOrName === undefined || typeof idxOrName === "number" ? _this.array[idxOrName || 0] : _this.array.find(function (t) {
        return t.name === idxOrName;
      });
    };
    overridableContainer.addAbsorber = function (options, position) {
      return _this.addAbsorber(options, position);
    };
  }
  _createClass(Absorbers, [{
    key: "init",
    value: function init(options) {
      var _a, _b;
      if (!options) {
        return;
      }
      if (options.absorbers) {
        if (options.absorbers instanceof Array) {
          this.absorbers = options.absorbers.map(function (s) {
            var tmp = new Absorber();
            tmp.load(s);
            return tmp;
          });
        } else {
          if (this.absorbers instanceof Array) {
            this.absorbers = new Absorber();
          }
          this.absorbers.load(options.absorbers);
        }
      }
      var interactivityAbsorbers = (_b = (_a = options.interactivity) === null || _a === void 0 ? void 0 : _a.modes) === null || _b === void 0 ? void 0 : _b.absorbers;
      if (interactivityAbsorbers) {
        if (interactivityAbsorbers instanceof Array) {
          this.interactivityAbsorbers = interactivityAbsorbers.map(function (s) {
            var tmp = new Absorber();
            tmp.load(s);
            return tmp;
          });
        } else {
          if (this.interactivityAbsorbers instanceof Array) {
            this.interactivityAbsorbers = new Absorber();
          }
          this.interactivityAbsorbers.load(interactivityAbsorbers);
        }
      }
      if (this.absorbers instanceof Array) {
        var _iterator = _createForOfIteratorHelper(this.absorbers),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var absorberOptions = _step.value;
            this.addAbsorber(absorberOptions);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else {
        this.addAbsorber(this.absorbers);
      }
    }
  }, {
    key: "particleUpdate",
    value: function particleUpdate(particle) {
      var _iterator2 = _createForOfIteratorHelper(this.array),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var absorber = _step2.value;
          absorber.attract(particle);
          if (particle.destroyed) {
            break;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "draw",
    value: function draw(context) {
      var _iterator3 = _createForOfIteratorHelper(this.array),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var absorber = _step3.value;
          context.save();
          absorber.draw(context);
          context.restore();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      this.array = [];
    }
  }, {
    key: "resize",
    value: function resize() {
      var _iterator4 = _createForOfIteratorHelper(this.array),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var absorber = _step4.value;
          absorber.resize();
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, {
    key: "handleClickMode",
    value: function handleClickMode(mode) {
      var absorberOptions = this.absorbers,
        modeAbsorbers = this.interactivityAbsorbers;
      if (mode === "absorber") {
        var absorbersModeOptions;
        if (modeAbsorbers instanceof Array) {
          if (modeAbsorbers.length > 0) {
            absorbersModeOptions = itemFromArray(modeAbsorbers);
          }
        } else {
          absorbersModeOptions = modeAbsorbers;
        }
        var absorbersOptions = absorbersModeOptions !== null && absorbersModeOptions !== void 0 ? absorbersModeOptions : absorberOptions instanceof Array ? itemFromArray(absorberOptions) : absorberOptions,
          aPosition = this.container.interactivity.mouse.clickPosition;
        this.addAbsorber(absorbersOptions, aPosition);
      }
    }
  }, {
    key: "addAbsorber",
    value: function addAbsorber(options, position) {
      var absorber = new AbsorberInstance(this, this.container, options, position);
      this.array.push(absorber);
      return absorber;
    }
  }, {
    key: "removeAbsorber",
    value: function removeAbsorber(absorber) {
      var index = this.array.indexOf(absorber);
      if (index >= 0) {
        this.array.splice(index, 1);
      }
    }
  }]);
  return Absorbers;
}();